import r2wc from "@r2wc/react-to-web-component";
import { GuestsSelector } from "@fm/ui";

const GuestsSelectorWebComponent = r2wc(GuestsSelector, {
  props: {
    adults: "number",
    childrenCount: "number",
    infants: "number",
    pets: "number",
    onGuestsChange: "function",
    disabled: "boolean",
    className: "string",
  },
});

if (!customElements.get("fm-guests-selector")) {
  customElements.define("fm-guests-selector", GuestsSelectorWebComponent);
}
